import React, {useEffect, useState} from "react";
import {KoerberLoadingWrapper} from "./Loading.style";
import LoadingEllipsis from "./LoadingEllipsis/LoadingEllipsis";

const Loading = (props) => {
    const { type } = props;

    const [loadingType, setLoadingType] = useState('ellipsis');
    
    useEffect(() => {
        if(type) setLoadingType(type);
    }, []);

    return (
        <KoerberLoadingWrapper>
            {loadingType === "ellipsis" && <LoadingEllipsis />}
        </KoerberLoadingWrapper>
    )
}

export default Loading;
